import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Productconst from "./pages/Productconst";
import PearlGemsConstraints from "./pages/PearlGemsConstraints";
import BrandMachineToolDecorConstraints from "./pages/BrandMachineToolDecorConstraints";
import Homepage from "./pages/Homepage";
import Buyers from "./pages/Buyers.jsx";
import Buyer360 from "./pages/Buyer360.jsx";
import Sellers from "./pages/Sellers.jsx";
import Seller360 from "./pages/Seller360.jsx";
import AdminOtpSender from "./pages/AdminOtpSender";
import ProductApproval from "./pages/ProductApproval";
import ProductsRegistrationReq from "./pages/ProductsRegistrationReq";
import JREManagement from "./pages/JREManagement";
import OperatorZoneManager from "./pages/OperatorZoneManager";
import OpenMarketOrderApproval from "./pages/OpenMarketOrdersApproval";
import AreaDefault from "./pages/AreaDefault";
import RateConstraint from "./pages/RateConstraint";
import CourierManagement from "./pages/CourierManagement";
import PlatformOnboardingRequests from "./pages/PlatformOnboardingRequests";
import OrderReceived from "./pages/OrderReceived";
import OrderApproved from "./pages/OrderApproved";
import OrderRTD from "./pages/OrderRTD";
import InWarehouse from "./pages/InWarehouse";
import OrderDispatched from "./pages/OrderDispatched";
import OrderDelivered from "./pages/OrderDelivered";
import PaymentsPending from "./pages/PaymentsPending";
import PaymentsReceived from "./pages/PaymentsReceived";
import PaymentsToBePaid from "./pages/PaymentsToBePaid";
import PaymentsPaid from "./pages/PaymentsPaid";
// 🔒 Protected Route Wrapper
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  return user && user.mobile ? children : <Navigate to="/superadminlogin" replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Root redirect */}
          <Route
            path="/"
            element={<Navigate to="/superadminlogin" replace />}
          />

          {/* Public routes */}
          <Route path="/superadminlogin" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/sendOTP" element={<AdminOtpSender />} />
          {/* Protected routes */}
          <Route
            path="/buyers"
            element={
              <ProtectedRoute>
                <Buyers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/buyers/:buyerId"
            element={
              <ProtectedRoute>
                <Buyer360 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sellers"
            element={
              <ProtectedRoute>
                <Sellers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sellers/:sellerId"
            element={
              <ProtectedRoute>
                <Seller360 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/homepage"
            element={
              <ProtectedRoute>
                <Homepage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/productconst"
            element={
              <ProtectedRoute>
                <Productconst />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pearlgemsconst"
            element={
              <ProtectedRoute>
                <PearlGemsConstraints />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brandmachineteoldecorconst"
            element={
              <ProtectedRoute>
                <BrandMachineToolDecorConstraints />
              </ProtectedRoute>
            }
          />
          <Route
            path="/productsrequest"
            element={
              <ProtectedRoute>
                <ProductApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/productsregistrationreq"
            element={
              <ProtectedRoute>
                <ProductsRegistrationReq />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jre"
            element={
              <ProtectedRoute>
                <JREManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operatormanager"
            element={
              <ProtectedRoute>
                <OperatorZoneManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/openmarketordersapproval"
            element={
              <ProtectedRoute>
                <OpenMarketOrderApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rateconstraint"
            element={
              <ProtectedRoute>
                <RateConstraint />
              </ProtectedRoute>
            }
          />
          <Route
            path="/couriermanagement"
            element={
              <ProtectedRoute>
                <CourierManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/area-default"
            element={
              <ProtectedRoute>
                <AreaDefault />
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding-requests"
            element={
              <ProtectedRoute>
                <PlatformOnboardingRequests />
              </ProtectedRoute>
            }
          />
          {/* Orders — ported from the operator app (superadmin sees all operators) */}
          <Route
            path="/orders/received"
            element={
              <ProtectedRoute>
                <OrderReceived />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/approved"
            element={
              <ProtectedRoute>
                <OrderApproved />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/rtd"
            element={
              <ProtectedRoute>
                <OrderRTD />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/in-warehouse"
            element={
              <ProtectedRoute>
                <InWarehouse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/dispatched"
            element={
              <ProtectedRoute>
                <OrderDispatched />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/delivered"
            element={
              <ProtectedRoute>
                <OrderDelivered />
              </ProtectedRoute>
            }
          />
          {/* Payments — ported from the operator app */}
          <Route
            path="/payments/pending"
            element={
              <ProtectedRoute>
                <PaymentsPending />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments/received"
            element={
              <ProtectedRoute>
                <PaymentsReceived />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments/to-be-paid"
            element={
              <ProtectedRoute>
                <PaymentsToBePaid />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments/paid"
            element={
              <ProtectedRoute>
                <PaymentsPaid />
              </ProtectedRoute>
            }
          />
          {/* Catch-all */}
          <Route
            path="*"
            element={<Navigate to="/superadminlogin" replace />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
